<ng-content select="slnk-shared-input-validator-item">
</ng-content>
